export const optionBar = {
  xAxis: {
    name: 'Score\n(star)',
    type: 'category',
    data: ['1', '2', '3', '4', '5']
  },
  yAxis: {
    name: 'count Driver',
    type: 'value'
  },
  series: [
    {
      data: [1, 2, 10, 15, 10],
      type: 'bar'
    }
  ]
}
